<button type="button" (click)="exitGame()"  matTooltip="{{ 'buttons.txtExitGame' | translate }}">
    <span class="material-symbols-outlined">logout</span>
</button>